module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image-h"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0004-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "h3",
    attrs: {
      "id": "lev172"
    }
  }, [_vm._v("THE ARABIAN HORSE.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("THERE is scarcely an Arabian, how poor soever in other respects, but is possessed of his Horse, which he considers as an invaluable treasure. Having no other dwelling but a tent, the Arabian and his Horse live upon the most equal terms: his wife and family, his mare and her foal, generally lie indiscriminately together; whilst the little children frequently climb without fear upon the body of the inoffensive animal, which permits them to play with and caress it without injury. The Arabs never beat their Horses; they speak to, and seem to hold friendly intercourse with them: they never whip them, and seldom, but in cases of necessity, make use of the spur. Their agility in leaping is wonderful; and if the rider happen to fall, they are so tractable as to stand still in the midst of the most rapid career. The Arabian Horses, in general, are less than the Race Horses of this ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("country; they are easy and graceful in their motions, and rather inclined to leanness. It is worthy of remark, that, instead of crossing the breed, the Arabs take every precaution to keep it pure and unmixed: they preserve, with the greatest care, and for an amazing length of time, the genealogies of their Horses: those of the first kind are called Nobles, being “of a pure and ancient race, purer than milk.” They have likewise two other kinds, which, having been degraded by common alliances, sell at inferior prices.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("From Arabia, the race of Horses has probably extended into Barbary and other parts of Africa; those being considered as next to the Arabian Horses in swiftness and beauty, though they are somewhat smaller.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v(".   .   .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('em', [_vm._v("Spanish Genette")]), _vm._v(" is held in great estimation: like the former, it is small, but beautiful, and extremely swift.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Horses of India and China are of a much less size and more vicious than those of this country, and many of them very small. One of these was some years ago brought into this country as a present to the Queen, measuring only nine hands in height.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0005-01.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7685252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226044859_09_ch1.vue
// module id = 78
// module chunks = 0